module.exports = __webpack_public_path__ + "img/vs-logo-md.3ed80917.webp";